<template>
<div>
   <nav class="navbar navbar-expand-md navbar-light fixed-top desktop">
      <div class="container">
        <a class="navbar-brand"><img src="@/assets/img/logo-header.svg" alt=""></a>
        <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div >
          <div class="ml-auto">
            <ul class="nav navbar-nav">
            </ul>
            <button class="profile">
              <div class="name">
                <div class="clearfix"></div>
              </div>
            </button>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </nav>

    <nav class="navbar navbar-expand-lg fixed-top navbar-light navbar-offcanvas mobile">
      <div class="container">
         <a class="navbar-brand mr-auto float-left" href="/home"><img src="@/assets/img/logo-header.svg" alt=""></a>
      </div>
    </nav>
  </div>  

  
</template>

<script>
export default {
  name: 'topo'
}  
</script>